// Root element of a geneui Alert rendered by the Toaster (see @geneui/components Alert `alert-holder`)
const AlertHolderSelector = '.alert-holder';

// Close icon container inside a geneui Alert (`ab-action-c`); clicking it removes the toaster
const AlertCloseButtonSelector = '.ab-action-c';

export { AlertHolderSelector, AlertCloseButtonSelector };
